export enum AccountGroupTypes {
  Sales = 10,
  Rep = 11,
  Agent = 30,
}
